import { RELEASE_FEATURES } from '~/utils/releaseFeatures'

export default defineNuxtRouteMiddleware((to) => {
    if (!RELEASE_FEATURES.aiVet && /^\/profile\/ai(?:\/|$)/.test(to.path)) {
        throw createError({statusCode: 404, statusMessage: 'Not Found'})
    }
})
